import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 24 17.76',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <defs>
      <clipPath id="home-clip-path">
        <path d="M0 0h24v17.76H0z" fill="none" />
      </clipPath>
    </defs>
    <g clipPath="url(#home-clip-path)">
      <path
        d="M3.787 11.413v6.347h6.026v-5.067h4.373v5.067h6.027v-6.347H24L12 0 0 11.413z"
        fill={fill}
        fillRule="evenodd"
      />
    </g>
  </svg>
);
export default SVG;
